/**
 * UL Community — Main JS Entry Point
 * Compiled to: assets/js/main.js
 */

import { initMobileNav }     from './animations/nav.js';
import { initStickyHeader }  from './animations/header.js';
import { initTestimonials }  from './animations/testimonials.js';
import { initGalleryFilter } from './animations/gallery.js';
import { initLegalToc }      from './animations/legal-toc.js';

document.addEventListener( 'DOMContentLoaded', () => {
  initMobileNav();
  initStickyHeader();
  initTestimonials();
  initGalleryFilter();
  initLegalToc();
} );
